<template>
  <consult-contact-panel
    :title="panelTitle"
    :subtitle="subtitle"
    date-placeholder="请选择开始服药日期"
    day-placeholder="请输入服药天数（不大于30天）"
    :show-use-days="true"
    :show-gan-zhi-controls="serviceIndex == 6"
    :show-ill-day="serviceIndex == 6"
    submit-button-text="开始咨询"
    :address-required="true"
    dialog-width="600px"
    :initial-contact="initialContact"
    :initial-use-date="initialUseDate"
    :initial-use-days="initialUseDays"
    :initial-ill-day="initialIllDay"
    :initial-gan-zhi-prescription-time-type="initialGanZhiPrescriptionTimeType"
    :initial-gan-zhi-prescription-hour-range="initialGanZhiPrescriptionHourRange"
    @back="goBack"
    @submit="onSubmit"
  />
</template>

<script>
import ConsultContactPanel from "../widgets/ConsultContactPanel.vue";

export default {
  components: { ConsultContactPanel },
  data() {
    return {
      mode: 1,
      serviceIndex: "",
      initialContact: null,
      initialUseDate: "",
      initialUseDays: "",
      initialIllDay: "",
      initialGanZhiPrescriptionTimeType: "",
      initialGanZhiPrescriptionHourRange: ""
    };
  },
  computed: {
    panelTitle() {
      if (this.mode == 2) return "自拟组方";
      return this.serviceIndex == -1 ? "通用方" : "古中医组方";
    },
    subtitle() {
      if (this.mode == 2) return "结合中医辨证理念，为患者个性化制定用药方案";
      return this.serviceIndex == -1 ? "使用通用方为患者制定用药方案" : "以古中医辨证思路为患者组方";
    }
  },
  created() {
    if (this.$route.query.mode) this.mode = this.$route.query.mode;
    this.serviceIndex = this.$route.query.serviceIndex;

    const contact = sessionStorage.getItem("contactList");
    const consultInfo = sessionStorage.getItem("consultInfo");
    if (!this.utils.isEmptyStr(contact)) {
      this.initialContact = JSON.parse(contact);
      sessionStorage.removeItem("contactList");
      sessionStorage.removeItem("submitData");
      sessionStorage.removeItem("consultInfo");
      sessionStorage.removeItem("visitRecordId");
    } else if (!this.utils.isEmptyStr(consultInfo)) {
      const consultObj = JSON.parse(consultInfo);
      this.initialContact = consultObj.contact;
      this.initialUseDate = consultObj.useDate;
      this.initialUseDays = consultObj.useDays;
      this.initialIllDay = consultObj.illDay || "";
      this.initialGanZhiPrescriptionTimeType = consultObj.ganZhiPrescriptionTimeType || "";
      this.initialGanZhiPrescriptionHourRange = consultObj.ganZhiPrescriptionHourRange || "";
    }
  },
  methods: {
    goBack() {
      if (!this.utils.isEmptyStr(this.fromPath) && this.fromPath != "/") this.$router.go(-1);
      else this.$router.replace("/");
    },
    onSubmit(payload) {
      sessionStorage.removeItem("visitRecordId");
      const consultInfo = {
        contact: payload.selectContact,
        useDate: payload.useDate,
        illDay: payload.illDay,
        ganZhiPrescriptionTimeType: payload.ganZhiPrescriptionTimeType,
        useDays: payload.useDays,
        ganZhiPrescriptionHourRange: payload.ganZhiPrescriptionHourRange
      };
      sessionStorage.setItem("consultInfo", JSON.stringify(consultInfo));
      sessionStorage.removeItem("submitData");
      if (this.mode == 2) {
        this.$router.push({ path: "/prescriptionInfo", query: { mode: this.mode } });
        return;
      }
      if (this.serviceIndex == -1) {
        this.$router.push({ path: "/GeneralPrescriptionInfo" });
      } else {
        this.$router.push({ path: "/prescriptionInfo" });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => { vm.fromPath = from.path; });
  }
};
</script>
